export const SET_OPENID = 'SET_OPENID';


export const SET_APPLICANTNAME = 'SET_APPLICANTNAME';
export const SET_APPLICANTIDNUMBER = 'SET_APPLICANTIDNUMBER';
export const SET_APPLICANTMOBILE = 'SET_APPLICANTMOBILE';
export const SET_APPLICANTEMAIL = 'SET_APPLICANTEMAIL';
export const SET_RECOGNIZEENAME = 'SET_RECOGNIZEENAME';
export const SET_RECOGNIZEEIDNUMBER = 'SET_RECOGNIZEEIDNUMBER';
export const SET_RECOGNIZEEMOBILE = 'SET_RECOGNIZEEMOBILE';
export const SET_RECOGNIZEEEMAIL = 'SET_RECOGNIZEEEMAIL';
export const SET_ISSHOWINSURED = 'SET_ISSHOWINSURED';


export const SET_VIN = 'SET_VIN';
export const SET_ENGINENO = 'SET_ENGINENO';
export const SET_BRANDMODEL = 'SET_BRANDMODEL';
export const SET_DEBUTDATE = 'SET_DEBUTDATE';
export const SET_ISCHANGENAME = 'SET_ISCHANGENAME';
export const SET_TRANSFERDATE = 'SET_TRANSFERDATE';
export const SET_ISLOAN = 'SET_ISLOAN';
export const SET_LENDERS = 'SET_LENDERS';
export const SET_OWNERNAME = 'SET_OWNERNAME';
export const SET_OWNERIDNUMBER = 'SET_OWNERIDNUMBER';
export const SET_OWNERMOBILE = 'SET_OWNERMOBILE';
export const SET_VEHICLEDTOOBJ = 'SET_VEHICLEDTOOBJ';
export const SET_VEHICLEOWNEROBJ = 'SET_VEHICLEOWNEROBJ';


export const SET_ISINITIALSTATE = 'SET_ISINITIALSTATE';
export const SET_QUOTATIONOBJ = 'SET_QUOTATIONOBJ';